import axios from "axios";

export class GitBranchService {
  private static rootUrl = '/git-branches';

  /**
   * Ruft alle verfügbaren Git Branches vom Server ab
   */
  static async getBranches(): Promise<string[]> {
    console.log("Hole Git-Branch-Daten...");
    try {
      const response = await axios.get(this.rootUrl);
      console.log("Git-Branches erfolgreich geladen:", response.data);
      return response.data.branches || [];
    } catch (error) {
      console.error("Fehler beim Laden der Git-Branches:", error);
      return ['main', 'development']; // Fallback zu Standard-Branches
    }
  }

  /**
   * Fügt einen neuen Git Branch hinzu
   */
  static async addBranch(branchName: string): Promise<string[]> {
    console.log(`Füge neuen Git-Branch hinzu: ${branchName}...`);
    try {
      const response = await axios.post(this.rootUrl, { branchName });
      console.log("Git-Branch erfolgreich hinzugefügt:", response.data);
      return response.data.branches || [];
    } catch (error) {
      console.error(`Fehler beim Hinzufügen des Git-Branches ${branchName}:`, error);
      throw error;
    }
  }

  /**
   * Entfernt einen Git Branch
   */
  static async removeBranch(branchName: string): Promise<string[]> {
    console.log(`Entferne Git-Branch: ${branchName}...`);
    try {
      const response = await axios.delete(this.rootUrl, { 
        data: { branchName } 
      });
      console.log("Git-Branch erfolgreich entfernt:", response.data);
      return response.data.branches || [];
    } catch (error) {
      console.error(`Fehler beim Entfernen des Git-Branches ${branchName}:`, error);
      throw error;
    }
  }

  /**
   * Überprüft, ob ein Git Branch im Repository existiert
   * @returns Ein Objekt { exists: boolean, message: string }
   */
  static async verifyBranch(branchName: string): Promise<{ exists: boolean; message: string }> {
    console.log(`Überprüfe Git-Branch: ${branchName}...`);
    try {
      const encodedBranchName = encodeURIComponent(branchName);
      const response = await axios.get(`${this.rootUrl}/verify?branchName=${encodedBranchName}`);
      console.log("Git-Branch-Verifizierung:", response.data);
      // Return the full object from the backend response
      return { 
        exists: response.data.exists || false,
        message: response.data.message || 'Keine Nachricht vom Server'
      };
    } catch (error: any) {
      console.error(`Fehler bei der Verifizierung des Git-Branches ${branchName}:`, error);
      // Return a default error object in case of failure
      return { 
        exists: false, 
        message: error.response?.data?.message || error.response?.data?.description || error.message || `Fehler bei der Verifizierung von ${branchName}` 
      };
    }
  }
} 